export default "__VITE_ASSET__BoG1rkeX__"